import React, {useEffect, useState, useMemo} from 'react';
import { connect } from 'react-redux';
// import { Actions as LEAVEACTIONS } from '../../store/actions/leaveActions';
import { Actions as EMPLOYEEACTIONS } from '../../../store/actions/employeeActions';

import Notes from '../../notes/Notes';
import {format,addMonths} from 'date-fns'

const EmployeeNotes = ({
  notes,
  nextToken,
  getEmployeeNotes,
  employeeId
}) => {

  useEffect(() => {
    getEmployeeNotes({})
  },[employeeId]);

  return (
    <Notes notes={notes} nextToken={nextToken} getMoreLogs={getEmployeeNotes}  />
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    tab: state.employee.tab || 'personal',
    notes: state.employee.notes && state.employee.notes.items || [],
	nextToken: state.employee.notes && state.employee.notes.nextToken
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({

	getEmployeeNotes: ({nextToken,from,to}) => {
  		// const employeeId = window.location.pathname.split('/')[3]

	    return dispatch(
	      EMPLOYEEACTIONS.getEmployeeNotes({
	      	agreementId: ownProps.agreementId,nextToken,from,to
	      })
	    )
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeNotes);
